import { ReactElement } from "react";
import { TemplateProps } from "../types";
import { MacItemValue } from "./remotecontrol/MacItem";

/* IOZone */

export enum ZoneBehaviors {
  NONE = 0b0,
  ALL = 0b1111,

  H24 = 0b1,
  DELAYED = 0b10,
  FOLLOWER = 0b100,
  IMMEDIATE = 0b1000,
}

export interface ZoneBehaviorItem {
  value: string;
  label: string | ReactElement;
  color: string;
  icon: ReactElement;
  order: number;
}

export enum ZoneTriggers {
  arm = "arm",
  disarm = "disarm",
  alarm = "alarm",
  manual = "manual",
}

export interface IOZoneValue {
  uuid: string;
  enabled: boolean;
  name: string | null;
  time?: number;
  delay?: number;
  eventAlarm: string;
  eventRecovery: string | null;
  zone: string;
  behavior: ZoneBehaviors;
  entryDelay?: number;
  trigger?: keyof typeof ZoneTriggers;
}

export interface TypeOption {
  value: string;
  label?: string | ReactElement;
  image?: string;
  double?: boolean;
  r?: boolean;
}

export interface IOZoneProps extends TemplateProps<IOZoneValue> {
  type: string; // IOPortType;
  index: number;
}

export interface IOPortValue {
  type: string; // IOPortType
  resistor: number | null;
  zoneValues: IOZoneValue[];
  maxZones: number;
  deleted?: boolean;
}

export interface IOPortProps extends TemplateProps<IOPortValue> {
  nr: number;
  onDelete?: Function;
}

/* IOSettings */
export interface IOPortItem {
  nr: number;
  value: IOPortValue;
}

export interface IOSettingsValue {
  uuid: string;
  protocol: "C" | "L" | null,
  mac: string | null;
  name?: string;
  ports: IOPortItem[];
  newItem?: boolean;
  deleted?: boolean;
}

export interface IOSettingsProps extends TemplateProps<IOSettingsValue> {
  index: number;
  panelTitle: string;
  onDelete?: Function;
}

export interface CodeNameValue {
  uuid: string;
  code: string;
  name: string | null;
  deleted?: boolean;
}

export interface Partition {
  uuid: string;
  code: string;
  name: string;
  // technical: boolean;
  home: boolean;
  followedPartitions?: string[];
  deleted?: boolean;
}

export interface PartitionListProps extends TemplateProps<CodeNameValue[]> {}

export interface PlistValues {
  [zoneId: string]: {
    [partitionId: string]: boolean;
  };
}

export interface ZonesPlistValue {
  [zoneId: string]: string;
}

export interface PartitionsAndZonesValue {
  partitions: Partition[];
  zonesPlists: ZonesPlistValue;
}

export interface DisplayZoneValue extends CodeNameValue {
  output?: boolean;
  disabled?: boolean;
  deleted?: boolean;
  entrydelay?: boolean;
  behavior: ZoneBehaviors;
  trigger?: keyof typeof ZoneTriggers;
  port?: number;
  enabled?: boolean;
  board?: number;
}

export interface SmartalarmUser {
  uuid: string;
  code: string;
  name: string;
  deleted?: boolean;
}

/* Smartalarm */

export interface ButtonSettingsValue {
  function: string;
  index?: number;
  state?: number;
  time?: number;
  partition?: string;
  press?: string;
  event?: string;
  zone?: string;
}

export interface RemotecontrolValue {
  uuid: string;
  name: string;
  buttons: ButtonSettingsValue[] | null[];
  physical: MacItemValue[];
  newItem?: boolean;
  deleted?: boolean;
}

export interface RfidCardValue {
  uuid: string;
  user: string;
  hash: string;
  partition?: string;
  deleted?: boolean;
}
export interface RfidReaderValue {
  uuid: string;
  salt: string;
  name: string;
  board: string;
  protocol: "C" | "L" | null;
  mac?: string;
  port?: number;
  ports?: Array<number | null>;
  partition: string;
  exitDelay: number;
  cards: RfidCardValue[];
  deleted?: boolean;
}

export interface EntrydelayGroup {
  uuid: string;
  name: string;
  // kód?
  zones: string[];
  deleted?: boolean;
}
export interface SmartalarmValue {
  panels: IOSettingsValue[];
  plists: PartitionsAndZonesValue;
  entrydelays: EntrydelayGroup[];
  users: SmartalarmUser[];
  remotecontrol: RemotecontrolValue[];
  rfids: RfidReaderValue[];
}

export interface SmartalarmProps extends TemplateProps<SmartalarmValue> {
  onPartitionsChange?: Function;
}
